<template>
    <transition name="fade">
        <div class="full-image-modal" :class="{ is_single: isSingle }" v-if="isOpen" v-bsl="isOpen">
            <div class="row row--fullwidth">
                <div
                    class="col col--centered lg-10 sm-12"
                    :class="{ 'col--no-padding': !$device.isDesktop }"
                    v-click-outside="close">
                    <div class="full-image-modal__close text_11 like-link" @click="close">
                        <template v-if="$device.isDesktop">
                            {{ $t("close") }}
                        </template>
                        <template v-else>
                            <svg-icon name="close" width="32" height="32" />
                        </template>
                    </div>
                    <div
                        class="full-image-modal__arrow text_11 like-link"
                        @click="goToTop($event)"
                        v-if="$device.isDesktop">
                        <svg-icon name="arrow-top--big" width="40" height="40" />
                    </div>
                    <template v-if="$device.isDesktop && !isSingle">
                        <UiImage
                            v-for="(image, index) in existImages"
                            :path="image.path"
                            :key="index"
                            :desktop="{ width: 1630 }"
                            :class="{ is_active: current == index }"
                            alt="" />
                    </template>
                    <div v-if="!$device.isDesktop && isSingle" class="panzoom-container-container">
                        <div
                            v-if="images.length"
                            @click="updatePanZoom(localCurrent === 0 ? images.length - 1 : localCurrent - 1)"
                            class="panzoom-container__btn panzoom-container__btn--prev">
                            <svg-icon name="arrow_left--chevrone-16" width="16" height="13" />
                        </div>
                        <div
                            v-if="images.length"
                            @click="updatePanZoom(localCurrent === images.length ? 0 : localCurrent + 1)"
                            class="panzoom-container__btn panzoom-container__btn--next">
                            <svg-icon name="arrow_right--chevrone-16" width="16" height="13" />
                        </div>
                        <div
                            ref="panzoomContainer"
                            class="panzoom-container"
                            :options="{
                                minZoom: 1,
                                maxZoom: 4,
                                bounds: true,
                                transformOrigin: { x: 0.5, y: 0.5 },
                                boundsPadding: 1,
                                initialZoom: 1,
                            }">
                            <img
                                v-lazy-load :data-src="$img.resizeSimple(existImages.path, 1000, 0)"
                                v-lazy-load :data-srcset="`${$img.resizeSimple(existImages.path, 2000, 0)} 2x`"
                                alt=""
                                @load="isLoading = false"
                                ref="zoom-img"
                                class="zoomed-img" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import panzoom from "panzoom/dist/panzoom.min.js";
import UiImage from "./ui/Image.vue";

export default {
    components: { UiImage },
    props: ["isOpen", "images", "current", "isSingle"],
    data() {
        return {
            panzoomInstance: null,
            localCurrent: this.current,
            isLoading: false,
        };
    },
    watch: {
        isOpen(val) {
            if (val) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.initPanzoom();
                    }, 100);
                });
            }
        },
        current(v) {
            this.localCurrent = v;
        },
    },
    computed: {
        existImages() {
            if (this.isSingle) return this.images[this.localCurrent];
            return this.images.filter((item) => item.path);
        },
    },

    methods: {
        close() {
            this.$emit("close");
        },
        goToTop() {
            document.querySelector(".full-image-modal").scrollTop = 0;
        },
        updatePanZoom(index) {
            this.isLoading = true;
            this.localCurrent = index;
            this.initPanzoom();
        },
        initPanzoom() {
            if (this.panzoomInstance) {
                this.panzoomInstance.dispose();
            }

            if (!this.$refs["zoom-img"]) {
                return;
            }

            this.panzoomInstance = panzoom(this.$refs["zoom-img"], {
                minZoom: 1,
                maxZoom: 2,
                bounds: true,
                transformOrigin: { x: 0.5, y: 0.5 },
                boundsPadding: 1,
                initialZoom: 1,
            });

            this.panzoomInstance.moveTo(0, 0);
            this.panzoomInstance.zoomAbs(0, 0, 1);
        },
    },
    beforeDestroy() {
        if (this.panzoomInstance) {
            this.panzoomInstance.dispose();
        }
    },
};
</script>
<style lang="less">
.full-image-modal {
    position: fixed;
    overflow-y: auto;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background: rgba(242, 241, 233, 0.7);
    scroll-behavior: smooth;
    cursor: pointer;
    top: 72px;

    .has-promo-header & {
        top: 112px;
    }
    @media @sm {
        top: 36px;
        .has-promo-header & {
            top: 76px;
        }
    }
    &.is_single {
        .row,
        .col {
            height: 100%;
        }
    }

    picture {
        cursor: default;
        width: 100%;
        min-height: 100dvh;
        order: 1;
        img {
            min-height: 100dvh;
            object-fit: contain;
        }

        &.is_active {
            order: 0;
        }
    }

    .col {
        position: relative;
        display: flex;
        flex-direction: column;
    }

    &__close {
        border-bottom: 1px solid;
        top: 84px;

        .has-promo-header & {
            top: 124px;
        }
        @media @sm {
            top: 38px;
            .has-promo-header & {
                top: 89px;
            }
        }
        @media @sm {
            font-size: 0;
            width: 39px;
            height: 39px;
            background: #fff;
            border: 1px #000 solid;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    &__close,
    &__arrow {
        position: fixed;
        right: calc(50vw - 41.666667%);
        z-index: 1;
        margin-right: 64px;
        @media @sm {
            right: 16px;
            margin-right: 0;
        }
    }

    &__arrow {
        bottom: 24px;
    }
}
.panzoom-container-container {
    height: 100%;
}
.panzoom-container-container--loading {
    &::before {
        content: "";
        position: absolute;
        width: 32px;
        height: 32px;
        border: 2px solid #fff;
        border-top-color: transparent;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -16px;
        margin-left: -16px;
        z-index: 1;
        animation: spin 0.8s linear infinite;
    }
    .panzoom-container {
        &__btn {
            opacity: 0.5;
            pointer-events: none;
        }
    }
}
.panzoom-container {
    height: 100%;
    .zoomed-img {
        height: 100%;
        width: 100%;
        max-width: none;
        object-fit: contain;
    }
    &__btn {
        font-size: 0;
        width: 39px;
        height: 39px;
        background: #fff;
        border: 1px #000 solid;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        margin-top: -20px;
        z-index: 1;
        &--prev {
            left: 16px;
        }
        &--next {
            right: 16px;
        }
    }
}
</style>
